"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TitleSection_1 = __importDefault(require("@/components/DynamicTable/TitleSection"));
function SiteListTitleView({ onAddSite }) {
    return (react_1.default.createElement(TitleSection_1.default, { title: "Sites List", onAddRow: onAddSite, addRowButtonLabel: "Add site" }));
}
exports.default = SiteListTitleView;
